module.exports = __webpack_public_path__ + "static/media/003-fields.e106de01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/003-fields.png
// module id = 600
// module chunks = 0